import React from "react";
import PropTypes from "prop-types";
import Citations from "../../../../../../../components/Citations";

const InsilicoCitations = ({
  isDannDataIsAvailable,
  isDbnsfpDataIsAvailable,
}) => {
  return (
    <div className="tw-mr-2 tw-py-4">
      <Citations>
        {isDannDataIsAvailable ? (
          <div>
            <div>
              <strong>DANN Score</strong>
            </div>
            <p>
              Quang D, Chen Y, Xie X. DANN: a deep learning approach for
              annotating the pathogenicity of genetic variants. Bioinformatics.
              2015 Mar 1; 31(5): 761–763
            </p>
          </div>
        ) : null}
        {isDbnsfpDataIsAvailable ? (
          <div>
            <div>
              <strong>dbNSFP</strong>
            </div>
            <p>
              {
                "1. Liu X, Jian X, and Boerwinkle E. 2011. dbNSFP: a lightweight database of human non-synonymous SNPs and their functional predictions. "
              }
              <i>Human Mutation.</i>
              {" 32:894-899."}
            </p>
            <p>
              {
                "2. Liu X, Wu C, Li C and Boerwinkle E. 2016. dbNSFP v3.0: A One-Stop Database of Functional Predictions and Annotations for Human Non-synonymous and Splice Site SNVs. "
              }
              <i>Human Mutation.</i>
              {" 37:235-241."}
            </p>
            <p>
              {
                "3. Dong C, Wei P, Jian X, Gibbs R, Boerwinkle E, Wang K_ and Liu X_. (2015) Comparison and integration of deleteriousness prediction methods for nonsynonymous SNVs in whole exome sequencing studies. "
              }
              <i>Human Molecular Genetics</i>
              {" 24(8):2125-2137."}
            </p>
          </div>
        ) : null}
      </Citations>
    </div>
  );
};

InsilicoCitations.propTypes = {
  isDannDataIsAvailable: PropTypes.bool,
  isDbnsfpDataIsAvailable: PropTypes.bool,
};

InsilicoCitations.defaultProps = {
  isDannDataIsAvailable: false,
  isDbnsfpDataIsAvailable: false,
};

export default InsilicoCitations;
